import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { toastr } from "react-redux-toastr";

// utils
import { get, update } from "../../utils/apiService";

import EngagementStepConfigItem from "../EngagementStepConfigItem";
import Spinner from "../Spinner";

class EngagementChartConfigModal extends Component {
  constructor() {
    super();

    this.state = {
      isLoading: true,
      isSaving: false,
      isInvalid: true,
      engagementSteps: []
    };

    this.getData = this.getData.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.updateEngagementSteps = this.updateEngagementSteps.bind(this);
  }
  getData() {
    const { video } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/engagement_steps`;
    get(url)
      .then(res => {
        let engagementSteps = res.data.engagement_steps;
        this.setState({
          engagementSteps,
          isLoading: false
        });
      })
      .catch(err => {
        toastr.error("Erro carregando interatividades.");
      });
  }
  submitForm(event) {
    event.preventDefault();
    this.setState({
      isSaving: true
    });
    const { video } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/engagement_steps`;
    let data = {
      engagement_steps: this.state.engagementSteps
    };
    toastr.info("Salvando interatividades.");
    update(url, data)
      .then(res => {
        toastr.success("Interatividades salvas com sucesso.");
        this.props.close();
      })
      .catch(err => {
        toastr.error("Erro ao salvar interatividades.");
        this.setState({
          isSaving: false
        });
      });
  }
  updateEngagementSteps(newEngagementStep, isValid) {
    this.setState({
      isInvalid: !isValid
    });
    let newEngagementSteps = this.state.engagementSteps.map(engagementStep => {
      if (engagementStep.name === newEngagementStep.name) {
        return newEngagementStep;
      } else {
        return engagementStep;
      }
    });
    this.setState({
      engagementSteps: newEngagementSteps
    });
  }
  render() {
    const { show, close } = this.props;
    return (
      <Modal show={show} onHide={close} onEntered={this.getData}>
        <Modal.Header closeButton>
          <Modal.Title>Configurar gráfico de engajamento</Modal.Title>
        </Modal.Header>
        <form onSubmit={this.submitForm}>
          <Modal.Body>
            <Spinner isLoading={this.state.isLoading} />
            {this.state.engagementSteps.map((engagementStep, index) => (
              <EngagementStepConfigItem
                key={index}
                engagementStep={engagementStep}
                onUpdate={this.updateEngagementSteps}
              />
            ))}
          </Modal.Body>

          <Modal.Footer>
            <button type="button" className="btn btn-link" onClick={close}>
              Fechar
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              style={{ textTransform: "capitalize" }}
              disabled={
                this.state.isSaving ||
                this.state.isLoading ||
                this.state.isInvalid
              }
            >
              Salvar
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

EngagementChartConfigModal.propTypes = {};

export default EngagementChartConfigModal;



// WEBPACK FOOTER //
// ./src/components/modals/EngagementChartConfigModal.js